// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".redeemWrapper[data-v-810f72e6]{text-align:center;margin-top:25vh}.redeeming[data-v-810f72e6]{font-size:24px;font-weight:500;margin:40px 0}.md-progress-spinner[data-v-810f72e6]{stroke:#56fffe}.light .redeeming[data-v-810f72e6]{color:#000}.light .md-progress-spinner[data-v-810f72e6]{stroke:#000}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
